




import { defineComponent } from '@vue/composition-api';

/**
 * 何も表示しないダミー画面
 */
export default defineComponent({
  name: 'HomeView',
});
